import React, { useEffect, useMemo, useState } from "react";
import HeroHeader from "../components/HeroHeader";
import CategoryBar from "../components/CategoryBar";
import styles from "../styles/HomePage.module.css";
import CategoriesGrid from "./CategoriesGrid";
import OurTeam from "./OurTeam";
import PartnersAffiliates from "./PartnersAffiliates";
import { fetchHomePage } from "../helpers/contentfulHelper";

const HomePage = () => {
  const [homeEntry, setHomeEntry] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadHomePage = async () => {
      const entry = await fetchHomePage();
      if (!mounted) return;
      setHomeEntry(entry);
    };

    loadHomePage();

    return () => {
      mounted = false;
    };
  }, []);

  const intro = useMemo(() => {
    const fields = homeEntry?.fields || {};
    const heroFile = fields.heroImage?.fields?.file?.url;
    return {
      heading: fields.introHeading || "",
      copy: fields.introCopy || "",
      heroImage: heroFile ? `https:${heroFile}` : "",
      heroImageAlt: fields.heroImage?.fields?.title || "Home hero image",
    };
  }, [homeEntry]);

  const tiles = useMemo(() => {
    const tileEntries = homeEntry?.fields?.featureTiles || [];

    return tileEntries.map((tile) => {
      const tileFields = tile?.fields || {};
      const fileUrl = tileFields.image?.fields?.file?.url;

      return {
        title: tileFields.title || "",
        slug: tileFields.slug || "",
        order: tileFields.order,
        image: fileUrl ? `https:${fileUrl}` : "",
        imageAlt: tileFields.image?.fields?.title || tileFields.title || "Homepage feature",
      };
    });
  }, [homeEntry]);

  return (
    <main className={styles.home}>
      <HeroHeader
        heading={intro.heading}
        copy={intro.copy}
        imageSrc={intro.heroImage || undefined}
        imageAlt={intro.heroImageAlt}
      />
      <CategoryBar />
      <CategoriesGrid tiles={tiles} />
      <OurTeam />
      <PartnersAffiliates />
    </main>
  );
};

export default HomePage;
